// extracted by mini-css-extract-plugin
export default {"autocomplete":"Autocomplete_autocomplete__-RuXn","chip":"Autocomplete_chip__byn8v","row":"Autocomplete_row__fOBbO"};